export default (object, value) => {
	let result = false;
	for (const key in object) {
		if (object[key] === value) result = key;
	}
	return result;
};
